export const ADMIN_SISTEMA_PAGE = () => "/administracao";
export const ADMIN_USUARIOS_PAGE = () => "/administracao/usuarios";
export const ADMIN_CONFIGURACOES_PAGE = () => "/administracao/configuracoes";
export const ADMIN_LOGS_PAGE = () => "/administracao/logs";
export const ADMIN_CONSUMO_IA_PAGE = () => "/administracao/consumo-ia";
